"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _reactRedux = require("react-redux");

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

var _SelectedActions = require("../../redux/SelectedQuestion/SelectedActions");

require("../../../css/Properties.css");

var _CheckboxProperties = _interopRequireDefault(require("./CheckboxProperties"));

var _CommonProperties = _interopRequireDefault(require("./CommonProperties"));

var _DateProperties = _interopRequireDefault(require("./DateProperties"));

var _DropdownProperties = _interopRequireDefault(require("./DropdownProperties"));

var _NumberProperties = _interopRequireDefault(require("./NumberProperties"));

var _CloneFieldButton = _interopRequireDefault(require("./PropertyComponents/CloneFieldButton"));

var _DeleteFieldButton = _interopRequireDefault(require("./PropertyComponents/DeleteFieldButton"));

var _SaveButton = _interopRequireDefault(require("./PropertyComponents/SaveButton"));

var _RadioProperties = _interopRequireDefault(require("./RadioProperties"));

var _TextProperties = _interopRequireDefault(require("./TextProperties"));

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Properties = function Properties(_ref) {
  var selectedQuestion = _ref.selectedQuestion,
      selectedAnswer = _ref.selectedAnswer,
      updateSelectedQuestion = _ref.updateSelectedQuestion,
      setCurrentlySelectedQuestion = _ref.setCurrentlySelectedQuestion,
      deselectQuestion = _ref.deselectQuestion,
      cloneFormQuestion = _ref.cloneFormQuestion,
      removeQuestion = _ref.removeQuestion;

  var _useState = (0, _react.useState)(false),
      errorMessages = _useState[0],
      setErrorMessages = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      saveProperty = _useState2[0],
      setSaveProperty = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      showSaving = _useState3[0],
      setShowSaving = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      showDone = _useState4[0],
      setShowDone = _useState4[1];

  var _useState5 = (0, _react.useState)({
    question_type: 0,
    data: {
      pos: [],
      character_spacing: '0',
      opaque: false,
      overflow: 'expand',
      size: '12'
    },
    answers: [],
    required: true,
    prefill: null,
    name: 'default',
    question_type_translated: 'default'
  }),
      question = _useState5[0],
      setQuestion = _useState5[1];

  (0, _react.useEffect)(function () {
    if (selectedQuestion != null && question !== selectedQuestion) {
      setQuestion(selectedQuestion);
      setSaveProperty(false);
      setErrorMessages(false);
    } else if (!selectedQuestion) {
      setErrorMessages(false);
    } // eslint-disable-next-line

  }, [selectedQuestion]);
  (0, _react.useEffect)(function () {
    var delayDebounceFn;

    if (saveProperty) {
      delayDebounceFn = setTimeout(function () {
        // Only update if there's a valid question name
        // This prevents updates when just focusing on a field
        if (question.name && typeof question.name === 'string' && question.name.trim() !== '') {
          updateSelectedQuestion(question);
          setCurrentlySelectedQuestion(question, selectedAnswer);
        }
      }, 800); // Increase debounce time to give user more time to type
    }

    setSaveProperty(true);
    return function () {
      return clearTimeout(delayDebounceFn);
    }; // eslint-disable-next-line
  }, [question]);
  (0, _react.useEffect)(function () {
    var timer;

    if (showDone) {
      // this really needs to be ripped out and replaced with something sane. Like good state management.
      timer = setTimeout(function () {
        setShowDone(false);
        setShowSaving(false);
        deselectQuestion();
      }, 2000);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [showDone]);
  var _window$pdfFormConfig = window.pdfFormConfigObject.field_types,
      checkboxField = _window$pdfFormConfig.checkbox_field,
      countryField = _window$pdfFormConfig.country_field,
      dateField = _window$pdfFormConfig.date_field,
      decimalField = _window$pdfFormConfig.decimal_field,
      emailField = _window$pdfFormConfig.email_field,
      integerField = _window$pdfFormConfig.integer_field,
      moneyField = _window$pdfFormConfig.money_field,
      percentageField = _window$pdfFormConfig.percentage_field,
      phoneField = _window$pdfFormConfig.phone_field,
      radioField = _window$pdfFormConfig.radio_field,
      selectField = _window$pdfFormConfig.select_field,
      stateField = _window$pdfFormConfig.state_field,
      textField = _window$pdfFormConfig.text_field,
      textareaField = _window$pdfFormConfig.textarea_field,
      urlField = _window$pdfFormConfig.url_field,
      zipField = _window$pdfFormConfig.zip_field,
      signedInitialsField = _window$pdfFormConfig.signed_initials_field,
      signatureField = _window$pdfFormConfig.signature_field,
      _window$pdfFormConfig2 = _window$pdfFormConfig.multi_checkbox_field,
      multiCheckboxField = _window$pdfFormConfig2 === void 0 ? 27 : _window$pdfFormConfig2; // If this flag is true, we're in Onboarding and need to hide Radio; if not, we're in Apps

  var multiCheckboxEnabled = window.pdfFormConfigObject.enableMultiCheckbox !== false;
  var textTypes = multiCheckboxEnabled ? [textField, textareaField] : [textField, textareaField, emailField, countryField, phoneField, stateField, urlField, zipField];
  var numericTypes = [decimalField, integerField, moneyField, percentageField]; // Only show distinct RadioProperties if we're in Apps - otherwise Radios are handled by CheckboxProperties

  var radioTypes = multiCheckboxEnabled ? [] : [radioField]; // Only include multiCheckboxField and radioField if we're in Onboarding - otherwise it's Radios

  var checkboxTypes = multiCheckboxEnabled ? [checkboxField, radioField, multiCheckboxField] : [checkboxField];
  var signatureTypes = [signatureField, signedInitialsField];
  var answerTypes = [radioField, selectField];
  /**
  * When converting from a question that should have answers to one that does not,
  * we remove the answers
  */

  var saveQuestion = function saveQuestion(theQuestion) {
    if (answerTypes.includes(question.question_type)) {
      setQuestion(theQuestion);
    } else {
      setQuestion((0, _extends2["default"])({}, theQuestion, {
        answers: [],
        answers_attributes: []
      }));
    }
  };

  var handleSubmit = function handleSubmit(e) {
    var saving;
    var form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setErrorMessages(true);
    } else {
      e.preventDefault();
      updateSelectedQuestion(question);
      setErrorMessages(false);
      saving = setTimeout(function () {
        setShowDone(true);
      }, 1000);
      setShowSaving(true);
    }

    return function () {
      return clearTimeout(saving);
    };
  };

  var onCloneQuestion = function onCloneQuestion(questionWithoutId, newData) {
    cloneFormQuestion(questionWithoutId, newData);
  };

  var onDeleteQuestion = function onDeleteQuestion() {
    deselectQuestion();
    removeQuestion(selectedQuestion);
  };

  var getQuestionType = function getQuestionType() {
    switch (question.question_type_translated) {
      case 'Open Text Response':
        return 'Text';

      case 'Select - Choices (vertical layout)':
        return 'Radio';

      case 'Select - Dropdown':
        return 'Dropdown';

      case 'Decimal Number':
        return 'Number';

      default:
        return question.question_type_translated;
    }
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav, {
      className: "col-md-12 d-none d-md-block ",
      activeKey: "/home"
    },
    /*#__PURE__*/
    _react["default"].createElement("h6", null,
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "badge badge-pill text-uppercase index-scheme-0"
    }, getQuestionType())),
    /*#__PURE__*/
    _react["default"].createElement("h6", null,
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "badge badge-pill text-uppercase index-scheme-0"
    }, "Page \xA0", selectedQuestion && selectedQuestion.data ? selectedQuestion.data.page : null)),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form, {
      onSubmit: handleSubmit,
      noValidate: true
    },
    /*#__PURE__*/
    _react["default"].createElement(_CommonProperties["default"], {
      question: question,
      setQuestion: saveQuestion,
      textTypes: textTypes,
      numericTypes: numericTypes,
      checkboxTypes: checkboxTypes,
      signatureTypes: signatureTypes,
      errorMessages: errorMessages
    }), textTypes.includes(question.question_type) &&
    /*#__PURE__*/
    _react["default"].createElement(_TextProperties["default"], {
      question: question,
      questionType: question.question_type,
      setQuestion: setQuestion,
      errorMessages: errorMessages
    }), question.question_type === dateField &&
    /*#__PURE__*/
    _react["default"].createElement(_DateProperties["default"], {
      question: question,
      setQuestion: setQuestion,
      errorMessages: errorMessages
    }), numericTypes.includes(question.question_type) &&
    /*#__PURE__*/
    _react["default"].createElement(_NumberProperties["default"], {
      question: question,
      setQuestion: setQuestion,
      errorMessages: errorMessages
    }), question.question_type === selectField &&
    /*#__PURE__*/
    _react["default"].createElement(_DropdownProperties["default"], {
      question: question,
      errorMessages: errorMessages
    }), radioTypes.includes(question.question_type) &&
    /*#__PURE__*/
    _react["default"].createElement(_RadioProperties["default"], {
      question: question,
      errorMessages: errorMessages
    }), checkboxTypes.includes(question.question_type) &&
    /*#__PURE__*/
    _react["default"].createElement(_CheckboxProperties["default"], {
      question: question,
      setQuestion: setQuestion,
      errorMessages: errorMessages
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Row, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Col, {
      lg: "12",
      md: "12",
      xs: "12",
      className: "btn-row p-0"
    },
    /*#__PURE__*/
    _react["default"].createElement(_DeleteFieldButton["default"], {
      questionName: typeof question.name === 'string' ? question.name : String(question.name || ''),
      onDeleteQuestion: onDeleteQuestion
    }),
    /*#__PURE__*/
    _react["default"].createElement(_SaveButton["default"], {
      showDone: showDone,
      showSaving: showSaving
    }),
    /*#__PURE__*/
    _react["default"].createElement(_CloneFieldButton["default"], {
      onCloneQuestion: onCloneQuestion,
      selectedQuestion: selectedQuestion
    })))))))
  );
};

Properties.defaultProps = {
  selectedQuestion: null,
  selectedAnswer: null
};
Properties.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  selectedQuestion: _propTypes["default"].objectOf(_propTypes["default"].any),
  // eslint-disable-next-line react/forbid-prop-types
  selectedAnswer: _propTypes["default"].objectOf(_propTypes["default"].any),
  updateSelectedQuestion: _propTypes["default"].func.isRequired,
  setCurrentlySelectedQuestion: _propTypes["default"].func.isRequired,
  deselectQuestion: _propTypes["default"].func.isRequired,
  cloneFormQuestion: _propTypes["default"].func.isRequired,
  removeQuestion: _propTypes["default"].func.isRequired
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedQuestion: state.selectedQuestion.selectedQuestion,
    selectedAnswer: state.selectedQuestion.selectedAnswer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateSelectedQuestion: function updateSelectedQuestion(question) {
      return dispatch((0, _QuestionsActions.updateQuestion)(question, (0, _moment["default"])().format('LLL')));
    },
    setCurrentlySelectedQuestion: function setCurrentlySelectedQuestion(question, selectedAnswer) {
      return dispatch((0, _SelectedActions.setSelectedQuestion)(question, selectedAnswer));
    },
    deselectQuestion: function deselectQuestion() {
      return dispatch((0, _SelectedActions.unselectQuestion)());
    },
    cloneFormQuestion: function cloneFormQuestion(questionWithoutId, newData) {
      return dispatch((0, _QuestionsActions.cloneQuestion)((0, _extends2["default"])({}, questionWithoutId, {
        data: newData
      }), (0, _moment["default"])().format('LLL')));
    },
    removeQuestion: function removeQuestion(question) {
      return dispatch((0, _QuestionsActions.deleteQuestion)(question, (0, _moment["default"])().format('LLL')));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Properties);